var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderNextBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 40,
    viewBox: "0 0 22 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_14954_13787",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 15L16.0001 20L11.0001 25L9.93945 23.9393L13.8788 20L9.93945 16.0607L11.0001 15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 15L16.0001 20L11.0001 25L9.93945 23.9393L13.8788 20L9.93945 16.0607L11.0001 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 20L17.0608 21.0607L18.1214 20L17.0608 18.9393L16.0001 20ZM11.0001 15L12.0608 13.9393L11.0001 12.8787L9.93945 13.9393L11.0001 15ZM11.0001 25L9.93945 26.0607L11.0001 27.1213L12.0608 26.0607L11.0001 25ZM9.93945 16.0607L8.87879 15L7.81813 16.0607L8.87879 17.1213L9.93945 16.0607ZM9.93945 23.9393L8.87879 22.8787L7.81813 23.9393L8.87879 25L9.93945 23.9393ZM13.8788 20L14.9395 21.0607L16.0001 20L14.9395 18.9393L13.8788 20ZM17.0608 18.9393L12.0608 13.9393L9.93945 16.0607L14.9395 21.0607L17.0608 18.9393ZM12.0608 26.0607L17.0608 21.0607L14.9395 18.9393L9.93945 23.9393L12.0608 26.0607ZM9.93945 13.9393L8.87879 15L11.0001 17.1213L12.0608 16.0607L9.93945 13.9393ZM8.87879 25L9.93945 26.0607L12.0608 23.9393L11.0001 22.8787L8.87879 25ZM12.8181 18.9393L8.87879 22.8787L11.0001 25L14.9395 21.0607L12.8181 18.9393ZM8.87879 17.1213L12.8181 21.0607L14.9395 18.9393L11.0001 15L8.87879 17.1213Z",
    fill: "black",
    fillOpacity: 0.25,
    mask: "url(#path-1-inside-1_14954_13787)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNextBtn);
export default __webpack_public_path__ + "static/media/header-next-btn.72b676ef.svg";
export { ForwardRef as ReactComponent };